import BrandsComponent from '../../components/brandComponents/brands';
export default function Brands() {
	return <BrandsComponent />;
}
